<template>
    <div>
        <p>Export Space <span class="tag is-dark">Soon</span></p> <br/>

        <base-button
            class="is-primary"
            icon="fas fa-cloud-download-alt"
            text="Export space data"
            disabled="true"/>
    </div>
</template>

<script>
export default {
    name: 'SpaceSettingsExport',
    props: ['space'],
};
</script>
